

//   // Subscription to the event of adding product to the shopping cart
//   window.addEventListener('message', (event) => {
//     if (event.data && event.data.eventName === 'addShoppigCartItem') {
//       // Send product to Shopify Cart

//         const sku = event.data.payload.item.sku;

//         if (!sku) {
//             console.error('SKU is not defined');
//             return;
//         }

//         const quantity = 1;

//         // Create payload for Shopify cart API
//         const payload = {
//             items: [{
//                 id: sku,
//                 quantity: quantity
//             }]
//         };

//         console.log(wizartFittingRoom)

//         // window.wizartDK.onAddShoppigCartItem({ vendor_code: sku });
    
//         // Make AJAX request to Shopify cart API
//         // fetch('/cart/add.js', {
//         //     method: 'POST',
//         //     headers: {
//         //     'Content-Type': 'application/json'
//         //     },
//         //     body: JSON.stringify(payload)
//         // })
//         // .then(response => response.json())
//         // .then(data => {
//         //     console.log('Product added to cart:', data);
//         // })
//         // .catch(error => {
//         //     console.error('Error adding product to cart:', error);
//         // });

//       console.log({event}, 'addShoppigCartItem', 2);
//     }
//   }, false);


console.log({window})

const items = [];
const shoppingCartItems = [];
window.addEventListener(
  'message',
  (event) => {
    if (event.data && event.data.eventName === 'addShoppigCartItem') {
      shoppingCartItems.push({ vendor_code: event.data.payload.item.vendor_code });

        // event.data.payload.item.vendor_code is the product sku, lets get the product ID from shopify


        // window.variantLookup

        // Create payload for Shopify cart API
        const payload = {
            items: [{
                id: window.variantLookup[event.data.payload.item.vendor_code],
                quantity: 1
            }]
        };

        // Make AJAX request to Shopify cart API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Product added to cart:', data);
            $('.back-button--desktop').click();
            $('.openCartDrawer').click();
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
        });
        

      console.log('addShoppigCartItem', { shoppingCartItems });
      window.postMessage(
        {
          eventName: 'setShoppingCartStore',
          payload: shoppingCartItems,
        },
        '*',
      );
    }
    if (event.data && event.data.eventName === 'removeShoppigCartItem') {

        
      // Event handling
      const foundIndex = shoppingCartItems.findIndex(
        (item) => item.vendor_code === event.data.payload.item.vendor_code,
      );
      console.log(foundIndex);
      if (foundIndex !== -1) {
        shoppingCartItems.splice(foundIndex, 1);
        window.postMessage(
          {
            eventName: 'setShoppingCartStore',
            payload: shoppingCartItems,
          },
          '*',
        );
      }
      console.log('removeShoppigCartItem', { shoppingCartItems });
    }
  },
  false,
);